import EncryptService from "./EncryptionService";
class TokenService {
    static getUserDetails = () => {
        const encryptedToken = sessionStorage.getItem('token');
        if(!encryptedToken) {
            return null;
        }
        //EncryptService.decrypt
        const userDetails = JSON.parse((encryptedToken));
        return userDetails;
    }
    static setTokenDetails = (body) => {
        const stringfyBody = JSON.stringify(body);
        //EncryptService.encrypt
        const encrypedToken = (stringfyBody);
        sessionStorage.setItem('token',encrypedToken);
        
    }
}

export default TokenService;